import { render } from "./PlansDetail.vue?vue&type=template&id=2213f108&scoped=true&ts=true"
import script from "./PlansDetail.vue?vue&type=script&lang=ts"
export * from "./PlansDetail.vue?vue&type=script&lang=ts"

import "./PlansDetail.vue?vue&type=style&index=0&id=2213f108&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2213f108"]])

export default __exports__